/**
 * Проверит если есть на странице таблица table.smart-table - тогда будет загружен скрипт assets/template/js/smart-table.js
 */
export default function checkSmartTableOnPage() {
  let table_filter = $("table.smart-table");
  if (table_filter) {
    // Запрещаем перенос строки в ячейках с ценой
    table_filter.each(function () {
      let $table = $(this);
      let index = $table.find("td.no-sort").index();
      if (index === -1) {
        return;
      }
      $table.find("tr").each(function (i) {
        if (i === 0) {
          return;
        }
        let $tr = $(this);
        let $td = $tr.find("td").eq(index);
        if (!$td.length) {
          return;
        }
        $td.css("white-space", "nowrap");
      });
    });

    // Подгружаем smart-table
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "/assets/template/js/smart-table.js";
    document.getElementsByTagName("head")[0].appendChild(script);
  }
}
